import { Paper, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { useListCategories } from './categories-list.hook';
import { ListCategoriesUseCase } from '../../../Usecase/Categories/list-categories-usecase';
import { DestroyCategoriesUseCase } from '../../../Usecase/Categories/destroy-categories-usecase';
import { Can } from '../../../Components/Can';

interface ICategoriesList {
  listCategoriesUseCase: ListCategoriesUseCase
  destroyCategoriesUseCase: DestroyCategoriesUseCase
}

const CategoriesList : FC<ICategoriesList> = ({ listCategoriesUseCase, destroyCategoriesUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { listCategories, list, setCategoryToDestroy, categoryToDestroy ,totalRegisters, handleDestroyCategory } = useListCategories({
      listCategoriesUseCase,
      destroyCategoriesUseCase,
      
      
    })

    useEffect(() => {
        listCategories({ page: 1 })
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
        
          {
            field: 'name',
            headerName: 'Nome',
            flex: 1,
          },
          {
            field: 'store',
            headerName: 'Loja',
            flex: 1,
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "right",
            flex: 1,
            renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={setCategoryToDestroy} editLink={`/categories-form/${params.row.id}`} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:categories:manage']}>
        <BaseScreen>
        <ConfirmDialog title='Remover Categoria' onCancel={() => setCategoryToDestroy('')} description='Você tem certeza?' open={!!categoryToDestroy} onConfirm={handleDestroyCategory}  /> 
            <Paper >
                <BaseContentPage 
                    title='Categorias / Marcas'
                    breadcrumb={[{ title: 'Categorias - Marcas', link: "/categories-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/categories-form')}>Adicionar</Button>}
                >
                  {!!list?.length ? <Table data={list} totalCount={totalRegisters} columns={columns} onPageChange={listCategories} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
      </Can>
    )
}

export { CategoriesList };
